import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { FeApi, useInjectFeApiContext } from '@/api/fe-api';
import { useMe } from '@/hooks/use-me';

export namespace UpdateUserInfo {
  export type Input = {
    firstName: string;
    lastName: string;
  };

  export type Output = void;

  export function useMutation() {
    const { uuid: userUuid } = useMe();
    const updatePreferences = useInjectFeApiContext(
      FeApi.usersV1PreferencesPartialUpdate,
    );
    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(input): Promise<Output> {
        if (!userUuid) {
          throw new Error('User UUID is undefined');
        }

        await ok(
          updatePreferences({
            userUuid,
            patchedUpdateUserPreferencesInputRequest: {
              first_name: input.firstName,
              last_name: input.lastName,
            },
          }),
        );
      },
    });
  }
}
